import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { CollaborationGraph } from './collaboration-graph';
import { CONTEXT_USER_ID, MAX_CG_RESULTS, QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT } from './collaboration-graph-client';
export class CollaborationGraphSingleSite extends CollaborationGraph {
  constructor({
    collaborationGraphUrl: url
  }) {
    super({
      url
    });
    _defineProperty(this, "CONTAINER_URL_PATH", 'v1/collaborationgraph/user/container');
    _defineProperty(this, "USER_URL_PATH", 'v1/collaborationgraph/user/user');
  }
  getUsers(arg) {
    return this.usersCache.get(arg).value;
  }
  getContainers({
    containerTypes,
    cloudId
  }) {
    return this.containersCache.get({
      containerTypes,
      cloudId
    }).value;
  }
  async getContainersSupplier({
    containerTypes,
    cloudId
  }) {
    const body = {
      containerTypes,
      context: {
        principalId: CONTEXT_USER_ID,
        siteId: cloudId,
        contextType: QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT
      },
      maxNumberOfResults: MAX_CG_RESULTS,
      userId: CONTEXT_USER_ID,
      expanded: true
    };
    const {
      result,
      durationMs
    } = await this.makeRequest(this.CONTAINER_URL_PATH, body);
    result.collaborationGraphEntities = result.collaborationGraphEntities.map(cgEntity => {
      return {
        ...cgEntity,
        siteId: cloudId
      };
    });
    return {
      ...result,
      timings: durationMs
    };
  }
  async getUsersSupplier({
    cloudId = '',
    collabGraphSessionId = ''
  }) {
    const body = {
      context: {
        principalId: CONTEXT_USER_ID,
        siteId: cloudId,
        sessionId: collabGraphSessionId,
        contextType: QUICK_SEARCH_COLLABORATION_GRAPH_CONTEXT
      },
      maxNumberOfResults: MAX_CG_RESULTS,
      userId: CONTEXT_USER_ID,
      expanded: true
    };
    const {
      result,
      durationMs
    } = await this.makeRequest(this.USER_URL_PATH, body);
    result.collaborationGraphEntities = result.collaborationGraphEntities.map(cgEntity => {
      return {
        ...cgEntity,
        siteId: cloudId
      };
    });
    return {
      ...result,
      timings: durationMs
    };
  }
}